import { useEffect, useState } from "react"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { LgFormInput, LgFormInputPassword } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../interfaces/Rest/types"
import { fetchWifiData, updateWifiSettings } from "../../components/Rest/commands/updateWifiSettings"
import { WifiSettingsProps } from "../../interfaces/AccumulatorWifi/types"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useRequiredSerialNumber } from "./useRequiredSerialNumber"

interface WifiSettingsFormState {
    data: WifiSettingsProps | undefined
    requestState: RestApiState
    timeOutId: NodeJS.Timeout | null
}

const defaultState: WifiSettingsFormState = {
    data: undefined,
    requestState: RestApiState.Idle,
    timeOutId: null,
}

const ASCII_LENGTH_PATTERN = /^[\x21-\x7E]{4,63}$/
const OPTIONAL_PASSWORD_PATTERN = /^$|^[\x21-\x7E]{4,63}$/

export const AcbWifiSettingsUpdate = (): JSX.Element => {
    const { user } = useSignedInContext()
    const serialNumber = useRequiredSerialNumber()
    const [formState, setFormState] = useState<WifiSettingsFormState>(defaultState)

    useEffect(() => {
        fetchWifiData(serialNumber, user.role_slug, (value: any) => {
            setFormState((prev) => ({
                ...prev,
                data: value,
            }))
        })
    }, [])

    const valueSetter = (e: any) => {
        const { name, value } = e.target
        setFormState((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: value,
            } as WifiSettingsProps,
        }))
    }

    const restStatusSetter = (value: RestApiState) => {
        setFormState((prev) => ({
            ...prev,
            requestState: value,
        }))
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        if (formState.data?.wifi_password === undefined) {
            throw new Error("File cant be empty")
        }
        if (!ASCII_LENGTH_PATTERN.test(formState.data.wifi_password) && formState.data.wifi_password !== "") {
            alert(
                "Пароль должен содержать от 4 до 63 символов и не может содержать пробелы, эмодзи или символы, отличные от ASCII."
            )
            return
        }
        restStatusSetter(RestApiState.Pending)
        updateWifiSettings(serialNumber, user.role_slug, formState.data, restStatusSetter)
    }

    const isSubmitDisabled =
        formState.data?.wifi_password === null ||
        formState.data?.wifi_password === undefined ||
        !OPTIONAL_PASSWORD_PATTERN.test(formState.data.wifi_password) ||
        formState.data?.wifi_ssid === undefined ||
        formState.data?.wifi_ssid === null ||
        formState.data.wifi_ssid === "" ||
        !ASCII_LENGTH_PATTERN.test(formState.data.wifi_ssid)

    return (
        <BoxWrapper bg="bg-transparent" r="r0" p="p0">
            <br />
            <form onSubmit={handleSubmit}>
                <FlexWrapper flexDirection="column" alignItems="start">
                    <LgFormInput
                        value={formState.data?.wifi_ssid}
                        label="Название сети (SSID)"
                        name="wifi_ssid"
                        type="text"
                        required={false}
                        valueSetter={valueSetter}
                        disabled={false}
                    />
                    <LgFormInputPassword
                        value={formState.data?.wifi_password}
                        label="Пароль"
                        name="wifi_password"
                        type="text"
                        required={false}
                        valueSetter={valueSetter}
                        disabled={false}
                        isPassword={true}
                    />
                    <SubmitButton
                        restState={formState.requestState}
                        disabled={isSubmitDisabled}
                        restHandler={{
                            timeOutId: formState.timeOutId,
                            setter: (key: "requestState" | "timeOutId", value: any) => {
                                setFormState((prev) => ({
                                    ...prev,
                                    [key]: value,
                                }))
                            },
                        }}
                    />
                </FlexWrapper>
            </form>
        </BoxWrapper>
    )
}
